export default "__VITE_ASSET__CymwmhNk__"